/**
 * Get documentation URL for destination types
 * @param {string} code - Destination type code
 * @returns {string} Documentation URL or empty string if not available
 */
export const getDestinationDocumentLink = (code) => {
    switch (code) {
        case "fbpixel":
            return "https://signalsight.io/docs/facebook-capi-setup.html";
        case "fbcapi":
            return "https://signalsight.io/docs/facebook-capi-setup.html";
        case "fboffline":
            return "https://signalsight.io/docs/facebook-capi-setup.html";
        case "ttpixel":
            return "https://signalsight.io/docs/tiktok-events-api-setup.html";
        case "ttcapi":
            return "https://signalsight.io/docs/tiktok-events-api-setup.html";
        case "ttoffline":
            return "https://signalsight.io/docs/tiktok-events-api-setup.html";
        case "scpixel":
            return "https://signalsight.io/docs/snapchat-capi-setup.html";
        case "sccapi":
            return "https://signalsight.io/docs/snapchat-capi-setup.html";
        case "pnpixel":
            return "https://signalsight.io/docs/pinterest-capi-setup.html";
        case "pncapi":
            return "https://signalsight.io/docs/pinterest-capi-setup.html";
        case "ggads":
            return "";
        case "twpixel":
            return "";
        case "twcapi":
            return "";
        case "alpixel":
            return "";
        default:
            return "";
    }
};

/**
 * Get documentation URL for source types
 * @param {string} code - Source type code
 * @returns {string} Documentation URL or empty string if not available
 */
export const getSourceDocumentLink = (code) => {
    switch (code) {
        case "sftp":
            return "https://signalsight.io/docs/secure-ftp-guide.html";
        case "upload":
            return "https://signalsight.io/docs/file-upload-source-guide.html";
        case "zoho":
            return "https://signalsight.io/docs/zoho-source-guide.html";
        case "hub":
            return "https://signalsight.io/docs/hubspot-source-guide.html";
        case "spreadsheet":
            return "https://signalsight.io/docs/spreadsheet-source-guide.html";
        case "ftp":
            return "https://signalsight.io/docs/secure-ftp-guide.html";
        case "freshsales":
            return "https://signalsight.io/docs/freshsales-source-guide.html";
        case "dynamics":
            return "https://signalsight.io/docs/dynamics-365-source-guide.html";
        case "salesforce":
            return "https://signalsight.io/docs/salesforce-source-guide.html";
        case "monday":
            return "https://signalsight.io/docs/monday-source-guide.html";
        case "zendesk_sell":
            return "https://signalsight.io/docs/zendesk-sell-source-guide.html";
        case "vtiger":
            return "https://signalsight.io/docs/vtiger-source-guide.html";
        case "odoo":
            return "https://signalsight.io/docs/odoo-source-guide.html";
        case "pipe":
            return "";
        case "bigquery":
            return "";
        case "appsflyer":
            return "https://www.signalsight.io/docs/appsflyer-web2app.html";
        case "adjust":
            return "https://www.signalsight.io/docs/adjust-web2app.html";
        case "lsqrd":
            return "https://signalsight.io/docs/leadsquared-source-guide.html";
        default:
            return "";
    }
};
